import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Article from "../pages/article/page";
import PillarPage from "../pages/pillar/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/pt",
    element: <Home />,
  },
  {
    path: "/en",
    element: <Home />,
  },
  {
    path: "/de",
    element: <Home />,
  },
  {
    path: "/pt/cssbuy-spreadsheet-guide",
    element: <Article />,
  },
  {
    path: "/en/cssbuy-spreadsheet-guide",
    element: <Article />,
  },
  {
    path: "/de/cssbuy-spreadsheet-guide",
    element: <Article />,
  },
  {
    path: "/pt/guide/:slug",
    element: <PillarPage />,
  },
  {
    path: "/en/guide/:slug",
    element: <PillarPage />,
  },
  {
    path: "/de/guide/:slug",
    element: <PillarPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;